import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { captureSource } from "@/lib/utils";

// Before React, deliberately. Effects run child-first, so anything placed in a
// component would fire after the pages inside it - and the page that reports
// the first funnel step is one of those. The visitor's very first landing_view
// would have gone out with no source at all, which is the one event where it
// matters most. Running here also covers every entry point at once: /demo,
// /faq, /terms and the rest, without a call scattered into each of them.
//
// Capturing is not the same as reporting. This decides what brought someone;
// landing_view is still sent only from the landing page.
captureSource();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
